<template>
  <rabbey-base-drawer
    :title="titleRow"
    size="70%"
    :drawer.sync="drawer"
    v-loading.fullscreen.lock="loading"
    :with-header="true"
    v-bind="$attrs"
    @close="OnClose"
    @closed="OnClose"
  >
    <el-row>
      <el-col>
        <el-form
          :model="dataApO"
          label-position="left"
          size="mini"
          label-width="120px"
        >
          <h2>{{ data.Name }}</h2>
          <div class="tags">
            <el-tooltip
              effect="dark"
              content="Clasificacion"
              placement="top-start"
              size="mini"
              :disabled="!data.Clasification"
            >
              <el-tag type="success" v-if="data.Clasification" size="mini">{{
                data.Clasification
              }}</el-tag>
            </el-tooltip>

            <el-tooltip
              effect="dark"
              content="Estatus"
              placement="top-start"
              :disabled="!data.Status"
              size="mini"
            >
              <el-tag type="success" v-if="data.Status" size="mini">{{
                data.Status
              }}</el-tag>
            </el-tooltip>

            <el-tooltip
              effect="dark"
              content="Dias de crédito"
              placement="top-start"
              :disabled="!data.PaymentDay"
              size="mini"
            >
              <el-tag type="success" v-if="data.PaymentDay" size="mini">{{
                data.PaymentDay
              }}</el-tag>
            </el-tooltip>

            <!-- <el-tag size="mini">{{ data.ClientType }}</el-tag> -->
            <!--
            <el-tooltip
              placement="top-start"
              :content="
                data.ContractStatus >= 1
                  ? 'Contrato del cliente abierto'
                  : 'Contrato del cliente cerrado'
              "
            >
              <el-tag
                :type="data.ContractStatus >= 1 ? 'success' : 'danger'"
                size="mini"
                >CN</el-tag
              >
            </el-tooltip> -->

            <template v-if="currentCompany === companys.MTR">
              <el-tooltip
                :content="
                  data.StatusNavixy
                    ? 'Servicio en Plataforma activo'
                    : 'Servicio en Plataforma desactivado'
                "
                placement="top-start"
                effect="dark"
              >
                <el-tag
                  :type="data.StatusNavixy ? 'success' : 'danger'"
                  size="mini"
                  >SP</el-tag
                >
              </el-tooltip>
            </template>

            <template v-if="data.OverdueBillsQty > 0">
              <el-tooltip
                content="Facturas vencidas"
                placement="top-start"
                effect="dark"
              >
                <el-tag type="danger" size="mini"
                  >FV: {{ data.OverdueBillsQty }}</el-tag
                >
              </el-tooltip>
            </template>
          </div>
          <hr />

          <el-row :gutter="20" type="flex column">
            <el-col :span="4" :xs="5" :sm="24" :md="24" :lg="8">
              <el-form-item label="Codigo">
                <el-input
                  v-model="dataApO.ProviderCode"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="RNC">
                <el-input v-model="dataApO.PRnc" :disabled="true" />
              </el-form-item>

              <el-form-item label="Telefono">
                <el-input
                  v-model="dataApO.P_PhoneNo"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="Proveedor">
                <el-input
                  v-model="dataApO.ProviderName"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="4" :xs="5" :sm="24" :md="24" :lg="8">
              <el-form-item label="Email">
                <el-input v-model="dataApO.PEmail" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="Direccion">
                <el-input v-model="dataApO.PAdress" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="Ciudad">
                <el-input v-model="dataApO.PCity" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="Moneda">
                <el-input
                  v-model="dataApO.PCurrecyC"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <!--

 -->
          </el-row>

          <el-row class="mt-20">
            <el-col>
              <el-tabs
                v-model="activeName"
                :before-leave="onBeforeLeave"
                @tab-click="clickTab"
              >
                <el-tab-pane label="Estado de cuentas" name="SCuentas">
                  <TbProviderAccStatus
                    ref="account_status"
                    :dataApO="dataApO"
                    :PeddingAmountSa="PeddingAmountSa"
                  />
                </el-tab-pane>
                <el-tab-pane label="Ordenes de Compras" name="Ocompras">
                  <OrderBuyPInside ref="Ocompras" :dataApO="dataApO" />
                </el-tab-pane>
                <el-tab-pane label="Interacciones" name="interactions">
                  <!-- <h1>Coming soon</h1> -->
                  <!-- <TableDocumentsPro/> -->

                  <TableInteractions
                    v-if="activeName === 'interactions'"
                    ref="interactions"
                    :clientCode="data.ClientCode"
                    :CustomerData="CustomerData"
                  />
                </el-tab-pane>
                <el-tab-pane label="Cotizaciones" name="Coti">
                  <h1>Coming soon</h1>
                  <!-- <TableSupports
                    v-if="activeName === 'Coti'"
                    ref="supports"
                    :clientCode="data.ClientCode"
                  /> -->
                </el-tab-pane>
                <!-- <el-tab-pane label="Estado de cuenta" name="account_status">
                  <TableAccountStatus
                    v-if="activeName === 'account_status'"
                    ref="account_status"
                    :clientCode="data.ClientCode"
                  />
                </el-tab-pane> -->
                <el-tab-pane label="Correos" name="contracts">
                  <!-- <span>Correos</span> -->
                  <!-- <el-badge slot="label" :value="totalContractNavisionComputed">
                  </el-badge> -->
                  <h1>Coming soon</h1>
                  <!-- <TableContracts
                    v-if="activeName === 'contracts'"
                    ref="contracts"
                    :clientCode="data.ClientCode"
                  /> -->
                </el-tab-pane>
                <el-tab-pane label="Propuesta Tecnica" name="proTecn">
                  <datapropuestaTecpro />
                </el-tab-pane>
                <el-tab-pane label="Propuesta Economia" name="proEconim ">
                  <dataPropuestEpro />
                </el-tab-pane>
                <!-- <el-tab-pane
                      label="Quejas o reclamaciones"
                      name="complaints"
                    >
                      <rabbey-table
                        ref="complaints"
                        index-url="/api/contacts/GetContactByCustomerCode"
                        @get:data="getComplaints"
                        :headers="columnComplaints"
                        :height="400"
                      />
                    </el-tab-pane> -->
                <!-- <el-tab-pane label="Equipos en Plataforma" name="gps">
                  v-if="currentCompany === companys.MTR"
                  <el-badge slot="label" :value="total_gps_by_user">
                    <span>Equipos en Plataforma</span>
                  </el-badge>

                  <TableGpsStatus
                    v-if="activeName === 'gps'"
                    ref="gps"
                    :clientCode="data.ClientCode"
                  />
                </el-tab-pane> -->
                <el-tab-pane label="Documentos" name="Clients_documents">
                  <DocumentListPro />
                </el-tab-pane>
                <!-- YOOO -->
                <!-- <el-tab-pane label="Cartas" name="Clients_cards">
                  <rabbey-toolbox
                    :filterables="true"
                    @filter-search="onFilterSearch"
                  ></rabbey-toolbox>
                  <div>
                    <vue-scroll class="page-dashboard">
                      <rabbey-toolbox :call-new="callNew" />
                      <el-row>
                         <el-col>
                          <rabbey-table3
                            ref="table"
                            :stripe="true"
                            :data="items"
                            :columns="columns"
                            :actions="actions"
                            :loading="loading"
                            @rtable-push-action="actionHandler"
                            @update-page-size="updatePageSize"
                            @update-current-page="updateCurrentPage"
                          />
                        </el-col>
                      </el-row>
                    </vue-scroll>
                    <el-dialog
                      title="Subir cartas"
                      :visible.sync="drawerCards"
                      width="30%"
                    >
                      <div id="div-legal">
                        <CustomersFilesUploader
                          :Visible="drawerCards"
                          UploadHeader="Cartas"
                          :DocumentType="6"
                          :CustomerCode="data.ClientCode"
                        />
                      </div>
                      <span slot="footer" class="dialog-footer">
                        <el-button v-on:click="closeDrawerCars"
                          >Cancel</el-button
                        >
                        <el-button type="primary" v-on:click="closeDrawerCars"
                          >Confirm</el-button
                        >
                      </span>
                    </el-dialog>
                  </div>
                </el-tab-pane> -->
              </el-tabs>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </rabbey-base-drawer>
</template>

<script>
import { COMPANYS } from "@/const";
import { formatPhoneNumber } from "@/utils";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import TableInteractions from "@/components/customers/TableInteractions.vue";
import DocumentListPro from "./DocumentListPro.vue";
import dataPropuestEpro from "./dataPropuestEpro.vue";
import datapropuestaTecpro from "./datapropuestaTecpro.vue";
import TbProviderAccStatus from "./TbProviderAccStatus.vue";
import OrderBuyPInside from "./OrderBuyPInside.vue";

export default {
  name: "CustomerDetail",
  inheritAttrs: false,
  components: {
    TableInteractions,
    DocumentListPro,
    dataPropuestEpro,
    datapropuestaTecpro,
    TbProviderAccStatus,
    OrderBuyPInside
  },
  props: {
    CustomerData: {
      type: Object
    },
    dataApO: {
      type: Object
    },
    ChangeActiveName: {
      type: String,
      default: ""
    },
    dataAp: {
      type: Array,
      default: () => []
    },
    PeddingAmountSa: {
      type: Number
    }
  },
  data() {
    return {
      companys: COMPANYS,
      activeColapseName: ["1"],
      data: {},
      // dataApO: {},
      // dataAp: [],
      codeP: "",
      drawer: false,
      drawerCards: false,
      titleRow: "Detalle de proveedor",
      loading: false,
      activeName: "SCuentas",
      totalContractNavisionByClient: 0,
      contractNo: "",
      UploadHeader: "",
      currentPage: 1,
      pageSize: 10,
      title: "",
      dialogVisible: false,
      items: [],
      columns: [
        {
          prop: "idClient",
          label: "Cliente code",
          width: 130,
          sortable: true
        },
        {
          prop: "id",
          label: "NO",
          width: 130,
          sortable: true
        },
        {
          prop: "name",
          label: "Descripcion",
          width: 220,
          sortable: true
          // sortable: true,
          // formatter: row => {
          //   return row.ISODocumentProcess.Name;
          // }
        },
        // {
        //   prop: "url",
        //   label: "Url del archivo",
        //   sortable: true,
        // },
        // {
        //   prop: "uid",
        //   label: "Uid del archivo",
        //   sortable: true
        // },
        {
          prop: "date",
          label: "Fecha de creacion",
          width: 150,
          sortable: true,
          formatter: DatetimeFormatter
        }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete"
        }
      ]
    };
  },
  methods: {
    formatPhoneNumber,
    // eslint-disable-next-line no-unused-vars
    onBeforeLeave(activeName, oldActiveName) {
      this.activeName = activeName;
      if (activeName === "gps") {
        this.$nextTick(() => {
          this.$refs.gps.getItems(this.data.ClientCode);
        });
      } else {
        this.$nextTick(() => {
          this.$refs[activeName].getItems();
        });
      }
      this.activeName = "SCuentas";
    },
    onFilterSearch(query) {
      this.$refs.table.filterData(query);
      this.GetDocuments();
      return;
    },
    clickTab(tab) {
      if (tab.label === "Cartas") {
        this.GetDocuments();
      }
    },
    async GetDocuments() {
      const Api = "/api/customers/getCustomersDocuments";
      //const params = `/EmployeeId=${EmployeeId}&DocumentType=${DocumentType}`;

      const params = {
        params: {
          CustomerCode: this.data.ClientCode,
          DocumentType: 6,
          IsEaneable: true
        }
      };
      this.items = []; //vaciar el array cuando sea llamado nuevamente
      await this.$http
        .get(Api, params)
        .then((resp) => {
          let { data } = resp;
          data.forEach((doc) => {
            this.items.push({
              idClient: doc.CustomerCode,
              id: doc.DocumentId,
              name: doc.DocumentName,
              url: doc.DocumentUrl,
              uid: doc.DocumentUid,
              date: doc.CreatedAt
            });
          });
        })
        .catch((err) => {
          console.error(
            `${err.name}:  ${err.message} `,
            "\n Error Detail: ",
            err
          );
          /*
          this.$message({
            type: "error",
            message: `${err.name}:  ${err.message} `,
            center: true
          });
          */
        })
        .finally(() => {});
    },
    GetProviders() {
      this.loading = true;
      this.$http
        .get(`/api/Proyects/GetProviders?companyCode=${this.companyCode}`)
        .then((resp) => {
          this.dataAp = resp.data;
          this.codeP = this.dataAp.ProviderCode;
          //  console.log("klk data: " + this.dataAp);
          //  console.log("klk codep: " + this.codeP);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          // console.log(this.dataAp)
        });
    },
    actionHandler(action) {
      switch (action.command) {
        case "view": {
          let link = document.createElement("a");
          link.href = action.row.url;
          link.target = "_blank";
          link.click();
          break;
        }
        case "delete": {
          this.$confirm(
            "This will permanently delete the file. Continue?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning"
            }
          )
            .then(() => {
              const Api = "/api/customers/disableCustomersDocuments";

              const params = {
                CustomerCode: action.row.idClient,
                DocumentType: 6,
                DocumentName: action.row.name,
                DocumentUrl: action.row.url,
                DocumentUid: action.row.uid,
                IsEaneable: false
              };
              this.$http
                .put(Api, params)
                .then((resp) => {
                  let { DocumentName } = resp.data;
                  this.$message({
                    showClose: true,
                    message: `Se ha eliminado el archivo "${DocumentName}" satisfactoriamente`,
                    type: "success",
                    center: true,
                    offset: 30
                  });
                  this.GetDocuments();
                })
                .catch((err) => {
                  this.$message({
                    type: "error",
                    message: `${err.name}:  ${err.message} `,
                    center: true
                  });
                })
                .finally(() => {});
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Se ha cancelado el borrado del documento"
              });
              this.items = [];
              this.GetDocuments();
            });
          break;
        }
      }
    },
    updatePageSize(val) {
      this.pageSize = val;
      this.GetDocuments();
    },
    updateCurrentPage(val) {
      this.currentPage = val;
      this.GetDocuments();
    },
    async show(data) {
      this.data = data;
      this.activeName = "SCuentas";
      this.drawer = true;

      // Encargado de buscar el total de gps para el badge
      await this._fetchGpsQty();

      // this.$nextTick(() => {
      //   this.$refs.contacts.getItems();
      // });

      // this.CountContractByClient();
    },
    async _fetchGpsQty() {
      if (this.currentCompany === this.companys.TB) {
        const userId = await this.$store.dispatch("navixy/searchUserId", {
          client_code: this.data.ClientCode
        });

        await this.$store.dispatch("navixy/reportGps12H", { sid: userId });
      }
    },

    // async CountContractByClient() {
    //   this.$http
    //     .get("/api/contracts/GetContratsCount", {
    //       timeout: 999999,
    //       params: {
    //         clientCode: this.data.ClientCode,
    //         companyCode: this.currentCompany
    //       }
    //     })
    //     .then(({ data }) => {
    //       this.totalContractNavisionByClient = data;
    //     })
    //     .catch((error) => {
    //       this.$message.error("Error al consultar los contratos");
    //       console.error(error);
    //       this.contractNo = 0;
    //     });
    // },

    OnClose() {
      this.ChangeActiveName = "";
      this.$store.dispatch("navixy/set_total_gps_by_user_to_default");
      this.drawerCards = false;
    },
    callNew() {
      this.title = "Nueva carta cliente";
      this.drawerCards = true;
    },
    closeDrawerCars() {
      this.GetDocuments();
      this.drawerCards = false;
    }
  },

  computed: {
    phone() {
      return this.formatPhoneNumber(this.data.PhoneNumber);
    },
    total_gps_by_user() {
      return this.$store.state.navixy.total_gps_by_user;
    },
    totalContractNavisionComputed() {
      return this.totalContractNavisionByClient;
    }
  },
  watch: {
    ChangeActiveName() {
      if (this.ChangeActiveName != "") {
        this.activeName = this.ChangeActiveName;
        this.ChangeActiveName = "";
      }
    }
  }
};
</script>

<style lang="scss">
.el-tabs__nav-scroll {
  .el-badge__content {
    &.is-fixed {
      top: 10px !important;
      right: 0px !important;
    }
  }
}

.tags span:not(:first-child) {
  margin-left: 5px;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
